<template>
    <Page v-if="screenSize === 'xs' || screenSize === 'sm'"
        type="gray" :nopadding="false" header="Переводы клиентов">
        <template v-slot:body>
            <ListMobile  :loading="loading" :list="transfers" :total="total" />
            <div v-if="!loading && transfers && total>0" class="surface-0 border-round-xl overflow-hidden mb-3">
                <Paginator v-model:first="skip" :rows="10" :totalRecords="total" template="PrevPageLink PageLinks NextPageLink "
                    @update:rows="onPageRowsChange($event)" @update:first="onPageChange($event)" />
            </div>
        </template>
    </Page>
    <PageFull v-else
        type="gray" :nopadding="false" header="Переводы клиентов">
        <template v-slot:body>
            <ListDesktop :loading="loading" :list="transfers" :total="total" :skip="skip"
                @onPageChange="onPageChange" @onFilter="onFilter" @onPageRowsChange="onPageRowsChange" />
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Page from '@/components/sides/Page.vue' 
import PageFull from '@/components/sides/PageFull.vue' 
import ListMobile from '@/components/merchant/transfer/ListMobile.vue' 
import ListDesktop from '@/components/merchant/transfer/ListDesktop.vue' 

export default {
    data() {
        return {
            // transfers: [],
            lazyParams: {},
            total: 0,
            loading: false,
            skip: 0
        }
    },
    components: {
        Page,
        PageFull,
        ListMobile,
        ListDesktop
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        async loadTransfers() {
            this.loading = true
            this.transfers = []
            this.total = 0
            window.scrollTo({ top: 0, behavior: 'smooth' })
            try {
                const transfers = await this.connect.transfers_mr_list(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters).then(res => res)
                console.log(transfers)
                if(transfers.result && transfers.data){
                    this.transfers = transfers.data
                    this.total = transfers.total
                } else {
                    if(transfers.message) this.showMess('error', 'Ошибка', transfers.message)
                    else this.showMess('error', 'Ошибка', 'Ошибка при получении списка переводов')
                }
            } catch (error) {
                this.showMess('error', 'Ошибка', 'Ошибка при получении списка переводов')
            }
            this.loading = false
        },
        onPageChange(val) {
            this.skip = val
            this.lazyParams.first = val
            this.loadTransfers()
        },
        onPageRowsChange(val) {
            this.lazyParams.rows = val
            this.loadTransfers()
        },
        onFilter(filters) {
            this.lazyParams.filters = filters
            this.loadTransfers()
        }
    },
    watch: {

    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        await this.loadTransfers().then(() => {})
    }
}
</script>